import { render, staticRenderFns } from "./editDespesa.vue?vue&type=template&id=728da446&scoped=true&"
import script from "./editDespesa.vue?vue&type=script&lang=js&"
export * from "./editDespesa.vue?vue&type=script&lang=js&"
import style0 from "./editDespesa.vue?vue&type=style&index=0&id=728da446&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728da446",
  null
  
)

export default component.exports